export { default } from 'features/offer/routes/offer-detail-route';
